<template>
  <div v-if="items.length > 0">
    <!-- H5导航 -->
    <div class="tab_wrap">
      <div class="tab_box">
        <ul ref="tab_ul_ref">
          <li
            v-for="(item, index) in items"
            :key="index"
            @click="tabSelected(item.cateId)"
            :ref="'tab_li' + item.cateId"
            :class="{ 
              active: navActiveTitle ? (navActiveTitle === item.cateId) : (index === 0)
            }"
          >
            <span>{{ item.cateName }}</span>
          </li>
        </ul>
        <!-- h5 more_box -->
        <div class="h5_more_box">
          <i class="icon-filled_all" @click="isMobleShow = true"></i>
        </div>
      </div>
    </div>
    <!-- 楼层信息 -->
    <div class="cc_box">
      <div class="cc_left_box" :style="{ top: pcTop || 0 }">
        <ul>
          <li
            v-for="(item, index) in items"
            :key="index"
            @click="tabSelected(item.cateId)"
            :class="{ 
              active: navActiveTitle ? (navActiveTitle === item.cateId) : (index === 0)
            }"
            :title="item.cateName"
          >
            <i>{{ item.cateName }}</i><span> ({{ item.itemsCount }})</span>
          </li>
        </ul>
      </div>
      <div class="cc_right_box">
        <div
          v-for="(item, index) in items"
          :ref="'shopFloor_' + item.cateId"
          :key="index"
        >
          <div class="shop_list_wrapper clearfloat">
            <div class="info">
              <h2>{{ item.cateName }}</h2>
              <p class="desc" v-if="item.desc">{{ item.desc}}</p>
            </div>
            <div
              class="col_box"
              v-for="(info, k) in item.items"
              :key="'shop' + k"
            >
              <ItemCard
                class="shop_item"
                :itemData="info"
                :cateId="item.cateId"
                :position="k"
                :cateIndex="index"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- h5 弹出 -->
    <div class="h5_drawer_box">
      <el-drawer
        :visible.sync="isMobleShow"
        direction="btt"
        :show-close="false"
        size="88%"
      >
        <div class="h5_list_box">
          <div class="pop_header">
            <i class="icon-outline_close" @click="isMobleShow = false"></i>
            <span v-text="shopInfo.shopName"></span>
          </div>
          <div class="pop_info_box">
            <ul>
              <li
                v-for="(item, index) in items"
                :key="index"
                @click.stop="tabSelected(item.cateId)"
                :class="{ active: navActiveTitle === item.cateId }"
              >
                {{ item.cateName }}<span> ({{ item.itemsCount }})</span>
              </li>
            </ul>
          </div>
        </div>
      </el-drawer>
    </div>
    <!-- // h5 弹窗 -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import animateScrollTo from 'animated-scroll-to';
import { sleep } from '@/utils/tools';
import ItemCard from '@/components/ItemCard';

export default {
  name: 'ScrollNav',
  components: {
    ItemCard,
  },
  props: {
    pcTop: String,
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  watch: {
    items: {
      handler() {
        if (this.items.length) {
          this.initDom();
          this.bindScroll();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      shopInfo: ({ store }) => store.shopInfo,
    })
  },
  data() {
    return {
      navActiveTitle: '',
      clientWidth: 0, // 视图宽度
      scrollWidth: 0, // 滚动宽度
      shopFloorInfo: [], // 楼层距离顶部信息
      disabled: false, // 滚动禁止
      isMobleShow: false, // h5弹窗
    };
  },
  mounted() {
  },
  methods: {
    // init
    initDom() {
      this.$nextTick(() => {
        this.getDomInfo();
        this.getShopFloorInfo();
      });
    },
    // 初始化获取楼层距顶部高度
    getShopFloorInfo() {
      const arr = [];
      this.items.forEach((item) => {
        const { cateId } = item;
        const shopFloor = this.$refs[`shopFloor_${cateId}`][0];
        if (shopFloor && shopFloor.offsetTop) {
          arr.push(shopFloor.offsetTop - 70);
        }
      });
      this.shopFloorInfo = arr;
    },
    // 获取DOM信息
    getDomInfo() {
      const _tab_ul = this.$refs.tab_ul_ref;
      const clientWidth = _tab_ul.clientWidth;
      const scrollWidth = _tab_ul.scrollWidth;

      this.clientWidth = clientWidth;
      this.scrollWidth = scrollWidth;

      if (scrollWidth > clientWidth) {
        this.$nextTick(() => {
          this.clientWidth = _tab_ul.clientWidth;
          this.scrollWidth = _tab_ul.scrollWidth;
        });
      }
    },
    // 点击导航
    tabSelected(cateId, tag) {
      this.isMobleShow = false;
      const refDom = this.$refs[`tab_li${cateId}`][0];

      animateScrollTo([refDom.offsetLeft - 80, 0], {
        elementToScroll: this.$refs.tab_ul_ref,
      });

      if (!tag) {
        this.getScrollTop(cateId);
      }

      this.navActiveTitle = cateId;
    },
    // 楼层滚动
    getScrollTop(cateId) {
      this.disabled = true;
      const shopFloor = this.$refs[`shopFloor_${cateId}`][0];

      if (shopFloor && shopFloor.offsetTop) {
        animateScrollTo([0, shopFloor.offsetTop - 50], {
          speed: 100,
        }).then(async () => {
          await sleep(100);
          this.disabled = false;
        });
      } else {
        window.scrollTop = 0;
        this.disabled = false;
      }
    },
    // 绑定滚动事件
    bindScroll() {
      document.addEventListener('scroll', this.onScroll);
    },
    // 页面滚动
    onScroll() {
      if (this.disabled) {
        return;
      }

      const { shopFloorInfo } = this;
      let scrollTop =
        document?.documentElement?.scrollTop || document?.body?.scrollTop;
      let index = 0;

      for (let i = 0; i < shopFloorInfo.length; i++) {
        if (shopFloorInfo[i] <= scrollTop && i === shopFloorInfo.length - 1) {
          index = i;
          break;
        }
        if (
          shopFloorInfo[i] <= scrollTop &&
          shopFloorInfo[i + 1] >= scrollTop
        ) {
          index = i;
          break;
        }
      }

      const cateId = this.items?.[index]?.cateId;
      this.tabSelected(cateId, true);
    },
    // 关闭移动端
    closeH5Dialog() {
      this.isMobleShow = false;
    },
  },
  deactivated() {
    document.removeEventListener('scroll', this.onScroll);
  },
  destroyed() {
    document.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style lang="scss" scoped>
.tab_wrap {
  width: 100%;
  height: 64px;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 1;
  display: none;
}

.tab_box {
  position: relative;
  margin: 0 auto;
  width: 1156px;
  height: 64px;
  display: flex;
  align-items: center;
  padding-right: 70px;

  // 隐藏滚动条
  ul::-webkit-scrollbar {
    display: none;
  }

  ul {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    overflow-x: scroll;
    li {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 24px;
      margin-right: 72px;
      flex-shrink: 0;
      cursor: pointer;
      color: #999;
      font-family: 'Aspira Light';
      &.active {
        border-bottom: 1.5px solid #333;
        font-size: 28px;
        color: #000000;
        font-family: 'Aspira Medium';
      }
    }
  }
}

.cc_box {
  margin: 17px auto 0;
  width: 1156px;
  display: flex;
  padding-bottom: 25px;
  .cc_left_box {
    width: 175px;
    top: 60px;
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    height: 100vh;
    overflow: auto;
    margin-right: 20px;
    li {
      padding-left: 12px;
      margin-top: 30px;
      width: 142px;
      font-family: 'Aspira Regular';
      font-size: 16px;
      line-height: 20px;
      color: #000;
      letter-spacing: 0;
      cursor: pointer;
      word-break: break-all;

      @include ellipsis(2);

      &:hover {
        color:#000;
        font-weight: 500;
      }

      &:first-child {
        margin-top: 24px;
      }

      &.active {
        color: #000;
        font-size: 18px;
        font-weight: bold;
        font-family: 'Aspira Medium';
        border-left: 2px solid #000;
        span {
          color: #000;
          font-size: 14px;
        }
      }
      i {
        font-style: normal;
        vertical-align: middle;
      }
      span {
        font-family: 'Aspira Light';
        font-size: 14px;
        color: #999;
        vertical-align: middle;
      }
    }
  }
  .cc_right_box {
    flex: 1;
  }
}

.shop_list_wrapper {
  clear: both;
  .info {
    padding-top: 25px;
    padding-bottom: 20px;
    h2 {
      font-family: 'Aspira Medium';
      font-size: 18px;
      font-weight: 500;
    }
    .desc {
      font-family: 'Aspira Light';
      font-weight: 200;
      font-size: 14px;
      line-height: 1;
      padding-top: 8px;
      color: #000;
    }
  }

  .col_box {
    float: left;
    margin-right: 20px;
  }
  .col_box:nth-child(3n+1) {
    margin-right: 0;
  }

  .shop_item {
    margin-bottom: 20px;
  }
}

.pop_info_box {
  padding-top: 10px;
  li {
    font-family: 'Aspira Light';
    font-size: 16px;
    color: #999;
    padding-bottom: 24px;
    line-height: 1;
    cursor: pointer;
    &.active {
      span {
        color: #000;
      }
      color: #000;
    }
    span {
      font-size: 16px;
      color: #999;
    }
  }
}

.h5_more_box {
  display: none;
}
</style>

<style  lang="scss" scoped>
// h5样式兼容
@media (max-width: 768px) {
  .tab_wrap {
    height: rem(84);
    display: block;
  }

  .tab_box {
    width: 100%;
    box-sizing: border-box;
    padding-left: rem(42);
    height: rem(84);

    ul {
      li {
        font-size: rem(36);
        margin-right: rem(52);
        max-width: rem(294);
        line-height: rem(84);
        &.active {
          border-bottom: 2px solid #333;
          font-size: rem(36);
        }
        &:active {
          color: #ccc;
        }
        span {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .h5_more_box {
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;
      text-align: right;
      padding-right: rem(39);
      box-sizing: border-box;
      width: rem(145);
      height: rem(82);
      background-image: linear-gradient(
        269deg,
        #ffffff 63%,
        rgba(245, 245, 247, 0) 100%
      );
      i {
        vertical-align: middle;
        font-size: rem(36);
      }
    }
  }
  .cc_box {
    width: 100%;
    padding: 0 rem(24);
    box-sizing: border-box;
    .cc_left_box {
      display: none;
    }
    .cc_right_box {
      padding-bottom: 80px;
    }
  }

  .shop_list_wrapper {
    .info {
      padding-top: (50);
      padding-bottom: (40);
      h2 {
        font-family: 'Aspira Medium';
        font-size: rem(36);
      }
      .desc {
        font-family: 'Aspira Light';
        font-size: rem(28);
        line-height: 1;
        padding-top: 6px;
        color: #000;
      }
    }
    .col_box {
      float: none;
      margin-right: 0;
    }
    .shop_item {
      margin-bottom: rem(20);
    }
  }

  .h5_drawer_box ::v-deep .el-drawer {
    border-top-left-radius: rem(12);
    border-top-right-radius: rem(12);
    transform: translate3d(0,0,0)
  }

  .h5_drawer_box ::v-deep .el-drawer__header {
    margin-bottom: 0;
    padding-top: 0;
  }

  .h5_drawer_box ::v-deep .el-drawer__body {
    background-color: #fff;
  }

  .h5_list_box {
    overflow-y: auto;
    height: 84vh;
    background-color: #fff;    
    .pop_header {
      position: sticky;
      top: 0;
      left: 0;
      background-color: #fff;
      text-align: center;
      line-height: rem(112);
      height: rem(112);
      i {
        position: absolute;
        left: rem(24);
        top: rem(45);
        font-size: rem(48);
      }
      span {
        display: inline-block;
        font-family: 'Aspira Medium';
        width: rem(550);
        font-weight: 500;
        font-size: 18px;
        color: #000;
       @include ellipsis(1);
      }
    }
  }
  .h5_dialog_content {
    position: relative;
    padding: 26px 12px 0;
    .h5-close {
      position: absolute;
      left: 12px;
      top: 24px;
      font-size: rem(48);
      cursor: pointer;
    }
    .h5-title {
      text-align: center;
      font-family: 'Aspira Light';
      font-size: rem(36);
      color: #000000;
      font-weight: 500;
      padding-bottom: 23px;
      box-sizing: border-box;
    }
  }

  .pop_info_box {
    padding-top: 0;
    ul {
      margin: 0 rem(48);
    }
    // 隐藏滚动条
    ul::-webkit-scrollbar {
      display: none;
    }

    li {
      font-family: 'Aspira Light';
      font-size: rem(32);
      color: #000;
      padding: rem(35) 0 rem(35) 0;
      line-height: 1;
      border-bottom: 1px solid #e6e6e6;
      &.active {
        span {
          color: #000;
        }
        color: #000;
      }
      span {
        font-size: rem(32);
        color: #999;
      }
    }
  }
}
</style>
